
    import './styles.scoped.css';
    export default {
  "flash-with-motion": "awsui_flash-with-motion_1q84n_io1ls_189",
  "enter": "awsui_enter_1q84n_io1ls_189",
  "flash-body": "awsui_flash-body_1q84n_io1ls_203",
  "flash-message": "awsui_flash-message_1q84n_io1ls_203",
  "flash-header": "awsui_flash-header_1q84n_io1ls_203",
  "flash-content": "awsui_flash-content_1q84n_io1ls_204",
  "action-button-wrapper": "awsui_action-button-wrapper_1q84n_io1ls_205",
  "dismiss-button-wrapper": "awsui_dismiss-button-wrapper_1q84n_io1ls_206",
  "flash-icon": "awsui_flash-icon_1q84n_io1ls_229",
  "entering": "awsui_entering_1q84n_io1ls_242",
  "entered": "awsui_entered_1q84n_io1ls_263",
  "exiting": "awsui_exiting_1q84n_io1ls_368",
  "stack": "awsui_stack_1q84n_io1ls_406",
  "animation-running": "awsui_animation-running_1q84n_io1ls_406",
  "item": "awsui_item_1q84n_io1ls_406",
  "flash-list-item": "awsui_flash-list-item_1q84n_io1ls_407",
  "notification-bar": "awsui_notification-bar_1q84n_io1ls_408",
  "collapsed": "awsui_collapsed_1q84n_io1ls_428",
  "animation-ready": "awsui_animation-ready_1q84n_io1ls_428",
  "expanded-only": "awsui_expanded-only_1q84n_io1ls_428",
  "expanded": "awsui_expanded_1q84n_io1ls_428",
  "flash": "awsui_flash_1q84n_io1ls_189",
  "collapsible": "awsui_collapsible_1q84n_io1ls_484",
  "short-list": "awsui_short-list_1q84n_io1ls_484",
  "visual-refresh": "awsui_visual-refresh_1q84n_io1ls_484",
  "status": "awsui_status_1q84n_io1ls_637",
  "header": "awsui_header_1q84n_io1ls_637",
  "item-count": "awsui_item-count_1q84n_io1ls_638",
  "button": "awsui_button_1q84n_io1ls_639",
  "type-count": "awsui_type-count_1q84n_io1ls_672",
  "count-number": "awsui_count-number_1q84n_io1ls_672",
  "icon": "awsui_icon_1q84n_io1ls_710",
  "floating": "awsui_floating_1q84n_io1ls_751",
  "flashbar": "awsui_flashbar_1q84n_io1ls_755",
  "initial-hidden": "awsui_initial-hidden_1q84n_io1ls_815",
  "flash-list": "awsui_flash-list_1q84n_io1ls_407",
  "flash-focus-container": "awsui_flash-focus-container_1q84n_io1ls_839",
  "flash-text": "awsui_flash-text_1q84n_io1ls_869",
  "hidden": "awsui_hidden_1q84n_io1ls_888",
  "header-replacement": "awsui_header-replacement_1q84n_io1ls_893",
  "content-replacement": "awsui_content-replacement_1q84n_io1ls_898",
  "dismiss-button": "awsui_dismiss-button_1q84n_io1ls_206",
  "action-wrapped": "awsui_action-wrapped_1q84n_io1ls_916",
  "action-button": "awsui_action-button_1q84n_io1ls_205",
  "action-slot": "awsui_action-slot_1q84n_io1ls_923",
  "flash-type-success": "awsui_flash-type-success_1q84n_io1ls_927",
  "flash-type-error": "awsui_flash-type-error_1q84n_io1ls_935",
  "flash-type-info": "awsui_flash-type-info_1q84n_io1ls_943",
  "flash-type-in-progress": "awsui_flash-type-in-progress_1q84n_io1ls_944",
  "flash-type-warning": "awsui_flash-type-warning_1q84n_io1ls_953"
};
  